app.directive('notificationBanner', ['NotificationService', 'NOTIFICATION_URGENCY_TYPE', function (NotificationService, NOTIFICATION_URGENCY_TYPE) {
    const urgencies = NOTIFICATION_URGENCY_TYPE.reduce((m, u) => { m[u.value] = u; return m; }, {});

    return {
        restrict: 'E',
        templateUrl: 'app/src/js/directives/notificationBanner.html',
        replace: false,
        link: function (scope) {
            function update() {
                const current = NotificationService.getCurrent();
                // A one-item list keyed by id, so the next banner gets a fresh element and its
                // entrance and countdown animations restart even when it replaces one in the same digest.
                scope.banners = current && current.message ? [current] : [];
                scope.urgency = current ? (urgencies[current.type] || urgencies.STANDARD) : null;
            }

            scope.clear = () => NotificationService.clear(scope.banners[0].notification_id);

            update();

            scope.$on('notificationChanged', update);
        }
    };
}]);
